import NavigationContainer from 'Navigation/Container/NavigationContainer';

export default NavigationContainer;
